export default __webpack_public_path__ + "static/media/hhs-qld-central-west.8e78d6a5.svg";